import { useContext } from "react";
import { Fragment } from "react/jsx-runtime";
import { Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CalendarContext } from "../../shared/VerticalCalendar";
import CalendarJobBox, { CalendarProjectName } from "./CalendarJobBox";
import { getBauleiterBlocks, type BauleiterCalendarRow } from "./bauleiterPeriods";

export default function BauleiterLine({ data, offset }: { data: BauleiterCalendarRow; offset: number }) {
  const view = useContext(CalendarContext);
  const navigate = useNavigate();
  if (!view) return null;

  return <Fragment>
    <div className="vc-sidebar calendar" data-bauleiter-id={data.id} style={{ gridRow: offset }}>
      <div className="vvss_name">{data.name}</div>
    </div>
    {getBauleiterBlocks(data.projects, view.calStart, view.calEnd, view.zoom).map(block => {
      const date = block.start.format("YYYY-MM-DD");
      return <div key={date} className="vc-date-res boxWrapper" data-calendar-bar="" data-date={date}
        style={{ gridRow: offset, gridColumnStart: block.start.diff(view.calStart, "days") + 2,
          gridColumnEnd: block.end.diff(view.calStart, "days") + 3 }}>
        {block.projects.map(project => (
          <CalendarJobBox key={project.id} projectId={project.id} zoom={view.zoom} booked draggable={false} tabIndex={0}
            data-bauleiter-project={project.id} title={`${project.name} (${project.number})`}>
            <div className="infocomp"><CalendarProjectName project={project} /></div>
            <div className="resOrderEdit">
              <button type="button" className="resOrderButton" aria-label={`Projekt ${project.name} (${project.number}) öffnen`}
                onClick={() => navigate(`/project/${project.id}`)}>
                <Search fontSize="inherit" />
              </button>
            </div>
          </CalendarJobBox>
        ))}
      </div>;
    })}
    <div className="vc-hl" style={{ gridRow: offset,
      gridColumn: `2 / ${view.calEnd.diff(view.calStart, "days") + 3}` }} />
  </Fragment>;
}
